import React from 'react';
import { withStyles, TextField } from '@material-ui/core'

const CssTextField = withStyles({
    root: {
      marginTop: '35px',
      marginBottom: '10px',
      fontSize: '14px',
      '& label': {
        color: '#878787',
        marginTop: '-20px'
      },
      '& label.MuiInputLabel-outlined.MuiInputLabel-shrink': {
        position: 'inherit',
        transform: 'translate(0px, -2px) scale(0.75)'
      },
      '& label.Mui-focused': {
        color: '#878787',
        marginTop: '-20px'
      },
      '& .MuiInput-underline:after': {
        borderBottomColor: 'green',
      },
      '& .MuiOutlinedInput-multiline': {
        padding: 0
      },
      '& .Mui-error': {
        color: '#red'
      },
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: '#E6EDF5',
          '& legend': {
            display: 'none'
          },
        },
        '&:hover fieldset': {
          borderColor: '#878787',
          borderWidth: '1px'
        },
        '&.Mui-focused fieldset': {
          borderColor: '#878787',
          borderWidth: '1px'
        },
      },
      '& .MuiOutlinedInput-input': {
        padding: '10px 12px',
        fontSize: '14px',
        color: '#656565',
        marginTop: '-4px',
        backgroundColor: 'white'
      }
  
    },
  })(TextField);

const TextFieldUI = (props) => {
    let { classes, ...other } = props;

    return (
        <CssTextField
            {...other}
        />
    )
}

export default TextFieldUI